import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";

import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import EditIcon from "@material-ui/icons/Edit";
import CancelIcon from "@material-ui/icons/Cancel";

import { useStyles } from "../../../../../Components/CSS/TableStyle.css";

class SectionBody extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editStatus: false,
    };
  }

  handleEditStatus = () => {
    this.setState({
      editStatus: true,
    });
  };

  handleCancelEditStatus = () => {
    this.setState({
      editStatus: false,
    });
  };

  handleEditSection = (index) => {
    this.props.handleEdit(index, this.props.sectionData);
    this.handleCancelEditStatus();
  };

  render() {
    const {
      classes,
      section,
      index,
      sectionData,
      handleSectionChange,
      handleDelete,
    } = this.props;
    return this.state.editStatus ? (
      <TableRow>
        <TableCell />
        <TableCell>
          <TextField
            name="name"
            type="text"
            label="sections"
            required
            fullWidth
            variant="outlined"
            margin="normal"
            placeholder="Enter the name of sections"
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={sectionData.name}
            onChange={handleSectionChange}
          />
        </TableCell>
        <TableCell align="center">
          <Tooltip
            title="Update"
            arrow
            className={classes.tooltip}
            onClick={() => this.handleEditSection(index)}
          >
            <EditIcon />
          </Tooltip>
          <Tooltip
            title="Cancel"
            arrow
            className={classes.tooltip}
            onClick={this.handleCancelEditStatus}
          >
            <CancelIcon />
          </Tooltip>
        </TableCell>
      </TableRow>
    ) : (
      <TableRow>
        <TableCell align="center">{index + 1}</TableCell>
        <TableCell align="center">{section.name}</TableCell>
        <TableCell align="center">
          <Tooltip
            title="Edit"
            arrow
            className={classes.tooltip}
            onClick={this.handleEditStatus}
          >
            <EditIcon />
          </Tooltip>
          <Tooltip
            title="Remove"
            arrow
            className={classes.tooltip}
            onClick={() => handleDelete(index)}
          >
            <RemoveCircleIcon />
          </Tooltip>
        </TableCell>
      </TableRow>
    );
  }
}

export default withStyles(useStyles)(SectionBody);
